module.exports = __webpack_public_path__ + "static/media/ins2.46e8b843.jpg";